import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import GamePage from './pages/GamePage';
import SubscriptionPage from './pages/SubscriptionPage';
import AISSubscriptionPage from './pages/AISSubscriptionPage';
import DTACSubscriptionPage from './pages/DTACSubscriptionPage';
import SubscriptionCallbackPage from './pages/SubscriptionCallbackPage';
import MsisdnCallbackPage from './pages/MsisdnCallbackPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path='/' element={<HomePage />} />
          <Route path='/game/:gameId' element={<GamePage />} />
          <Route path='/content/get/:gameId' element={<GamePage />} />
          <Route path='/subscription' element={<SubscriptionPage />} />
          <Route path='/subscription/ais' element={<AISSubscriptionPage />} />
          <Route path='/subscription/msisdn-callback' element={<MsisdnCallbackPage />} />
          <Route path='/subscription/dtac' element={<DTACSubscriptionPage />} />
          <Route path='/subscription/callback' element={<SubscriptionCallbackPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
